import { render } from "./ListPages.vue?vue&type=template&id=97e1d262"
import script from "./ListPages.vue?vue&type=script&lang=js"
export * from "./ListPages.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__